import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { Card, Tabs, Tooltip } from 'antd';
import CountAdjSync02SyncSetting from '../CountAdjSync02/CountAdjSync02SyncSetting';
import PcnSyncSetting from '../PcnSyncSetting/PcnSyncSetting';

import ProjectList01Table from '../ProjectList01/ProjectList01Table';

const { TabPane } = Tabs;

class GeneralManagementScreen extends React.PureComponent {
  componentDidMount() {}

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, appPath } = this.props;

    return (
      <Card>
        <Tabs type="card" activeKey={match.params.proc_type}>
          <TabPane
            tab={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Tooltip placement="bottom" title={intl.formatMessage({ id: `projects` })}>
                <Link
                  style={match.params.proc_type !== 'PROJECT_LIST_01' ? { color: 'black' } : {}}
                  to={`${appPath}/generalManagement/index/PROJECT_LIST_01`}
                >
                  <FormattedMessage id="project_list_01_label" />
                </Link>
              </Tooltip>
            }
            key="PROJECT_LIST_01"
          />
          <TabPane
            tab={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Tooltip placement="bottom" title={intl.formatMessage({ id: `projects` })}>
                <Link
                  style={match.params.proc_type !== 'COUNT_ADJ_SYNC_02' ? { color: 'black' } : {}}
                  to={`${appPath}/generalManagement/index/COUNT_ADJ_SYNC_02`}
                >
                  <FormattedMessage id="count_adj_sync_02_label" />
                </Link>
              </Tooltip>
            }
            key="COUNT_ADJ_SYNC_02"
          />

          <TabPane
            tab={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Tooltip placement="bottom" title={intl.formatMessage({ id: `projects` })}>
                <Link
                  style={match.params.proc_type !== 'PCN_SYNC_SETTING' ? { color: 'black' } : {}}
                  to={`${appPath}/generalManagement/index/PCN_SYNC_SETTING`}
                >
                  <FormattedMessage id="pcn_sync_setting_label" />
                </Link>
              </Tooltip>
            }
            key="PCN_SYNC_SETTING"
          />
        </Tabs>

        {match.params.proc_type === 'PROJECT_LIST_01' && <ProjectList01Table match={match} />}
        {match.params.proc_type === 'COUNT_ADJ_SYNC_02' && (
          <CountAdjSync02SyncSetting match={match} />
        )}
        {match.params.proc_type === 'PCN_SYNC_SETTING' && <PcnSyncSetting match={match} />}
      </Card>
    );
  }
}

GeneralManagementScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string
};

GeneralManagementScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: ''
};

const mapStateToProps = state => ({
  appPath: state.app.appPath
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(GeneralManagementScreen));
